import { useRef,useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import QuotationTable from "./QuotationTable";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import useLocalStorage from 'react-localstorage-hook'
import { FaLaptopHouse } from "react-icons/fa";

var k=0;

function App() {
  const itemRef = useRef();
  const ppuRef = useRef();
  const qtyRef = useRef();
  const discountRef = useRef();


  const [dataItems, setDataItems] = useLocalStorage("dataItems",[]);


  const dummyProductList = [
    { id: "p001", name: 'Samsung LED TV 52"', price: 15000 },
    { id: "p002", name: "Xiaomi Air Purifier", price: 4000 },
    { id: "p003", name: "Brother Laserjet Printer", price: 5500 },
    { id: "p004", name: "Bose Speaker", price: 20000 },
  ];
  const deleteItem=(i)=>{
    dataItems.splice(i,1)
    setDataItems([...dataItems])
  }


  const addItem = () => {
    var p=true;
    if (itemRef.current.value === "") {
      alert("Item name is empty");
      return;
    }
    const pid = itemRef.current.value;
    const product = dummyProductList.find((e) => e.id === pid);
    var after_change_qty=0;
    var item_list = localStorage.getItem==null?[]:JSON.parse(localStorage.getItem('dataItems'));
    if(item_list!=null){
    for( var q = 0; q < item_list.length; q++){
      var item_name = item_list[q].item;
      var item_price = item_list[q].ppu;
      var item_qty = item_list[q].qty;
      var sequence = item_list[q].sequences;
      if(product.name==item_name){
          if(ppuRef.current.value==item_price){
            after_change_qty=item_qty*1+qtyRef.current.value*1;
            p=false;
            deleteItem(q);
            k=0;
          }
      } 
    }
  }
  if(p==false){
    var itemObj = {
      sequences:k,
      pid: pid,
      item: product.name,
      ppu: ppuRef.current.value,
      qty: after_change_qty,
      discount:discountRef.current.value,
    };
  }else{
    var itemObj = {
      sequences:k,
      pid: pid,
      item: product.name,
      ppu: ppuRef.current.value,
      qty: qtyRef.current.value,
      discount:discountRef.current.value,
    };
  }
    dataItems.push(itemObj);
    setDataItems([...dataItems]);
    k+= 1;
  };

  const productChange = (e) => {
    const pid = itemRef.current.value;
    const product = dummyProductList.find((e) => e.id === pid);
    ppuRef.current.value = product.price
  }

  const options = dummyProductList.map((v) => {
    return <option value={v.id}>{v.name}</option>;
  });


  return (
    <Container>
      <Row>
        <Col xs={5} style={{ backgroundColor: "#eaeaea" }}>
          <Form>
            <Form.Group className="mb-3" controlId="formItem">
              <Form.Label>Item</Form.Label>
              <Form.Select
                aria-label="Default select example"
                ref={itemRef}
                onChange={productChange}
              >
                {options}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPrice">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Price Per Unit"
                ref={ppuRef}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formQauntity">
              <Form.Label>Quantity</Form.Label>
              <Form.Control type="number" placeholder="Quantity" ref={qtyRef} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formQauntity">
              <Form.Label>Discount</Form.Label>
              <Form.Control type="number" placeholder="Quantity" ref={discountRef} />
            </Form.Group>

            <Button variant="outline-dark" onClick={addItem}>
              Add
            </Button>
          </Form>
        </Col>
        <Col>
          <QuotationTable data={dataItems} setDataItems={setDataItems} />
        </Col>
      </Row>
    </Container>
  );
}

export default App;
